// utils.js - Basic utility functions

export function getRandomInt(min: number, max: number) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

function findGCD(a: number, b: number) {
    while (b !== 0) {
        const temp = b;
        b = a % b;
        a = temp;
    }
    return Math.abs(a);
}

export function calculateAnswer(problem: any): string | number {
    if (problem.type === 'mixedMultiplication') {
        const { whole, numerator, denominator } = problem.mixedNumber;
        const multiplier = problem.multiplier;
        
        // Convert mixed number to improper fraction
        const totalNumerator = (whole * denominator) + numerator;
        
        // Multiply by the multiplier
        const resultNumerator = totalNumerator * multiplier;
        const resultDenominator = denominator;
        
        // Convert back to mixed number
        const resultWhole = Math.floor(resultNumerator / resultDenominator);
        const remainingNumerator = resultNumerator % resultDenominator;
        
        // If there's no fractional part, just return the whole number
        if (remainingNumerator === 0) {
            return resultWhole;
        }
        
        // Find GCD to simplify the fraction
        const gcd = findGCD(remainingNumerator, resultDenominator);
        const simplifiedNumerator = remainingNumerator / gcd;
        const simplifiedDenominator = resultDenominator / gcd;
        
        // Return mixed number format
        if (resultWhole === 0) {
            return `${simplifiedNumerator}/${simplifiedDenominator}`;
        }
        return `${resultWhole} ${simplifiedNumerator}/${simplifiedDenominator}`;
    } else {
        const a = parseInt(problem.top.trim());
        const b = parseInt(problem.bottom.trim());
        
        switch(problem.operation) {
            case '+':
                return a + b;
            case '-':
                return a - b;
            case '×':
                return a * b;
            case '÷':
                // For division, calculate both quotient and remainder
                const quotient = Math.floor(a / b);
                const remainder = a % b;
                // Only show remainder if it's non-zero
                return remainder === 0 ? quotient : `${quotient} R ${remainder}`;
            default:
                return 0;
        }
    }
}

// State management for worksheet generation
export const state = {
    zeroUsedInWorksheet: false,
    minusOneCount: 0,
    MAX_MINUS_ONE: 3
};

export function resetState() {
    state.zeroUsedInWorksheet = false;
    state.minusOneCount = 0;
}